import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import AIChatPanel from '../AIChat/AIChatPanel';
import PrecisionAIIcon from '../shared/PrecisionAIIcon';
import MobileMenuDropdown from './MobileMenuDropdown';
import { MOBILE_BOTTOM_NAV_CLEARANCE } from '../../constants/mobileBottomNav';

/**
 * Full-screen PrecisionAI page for mobile bottom nav.
 * Wraps AIChatPanel with the standard mobile header chrome.
 */
const AskAIPage = ({ menuCurrentPage = 'askAI' }) => {
  const { colors } = useTheme();
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: '100dvh',
        maxHeight: '100dvh',
        boxSizing: 'border-box',
        overflow: 'hidden',
        backgroundColor: colors.bgPrimary,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 'env(safe-area-inset-top)',
        // Clearance for floating island bottom nav
        paddingBottom: MOBILE_BOTTOM_NAV_CLEARANCE,
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px',
          borderBottom: `1px solid ${colors.borderLight}`,
          gap: '8px',
          flexShrink: 0,
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="App"
          onClick={() => navigate('/home')}
          style={{
            height: 40,
            width: 40,
            objectFit: 'contain',
            cursor: 'pointer',
            flexShrink: 0,
            borderRadius: 8,
          }}
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
          <PrecisionAIIcon size={25} active />
          <h5 style={{ margin: 0, color: colors.text, fontSize: '1.1rem', fontWeight: '600' }}>
            PrecisionAI
          </h5>
        </div>
        <MobileMenuDropdown currentPage={menuCurrentPage} />
      </div>

      {/* Chat panel fills remaining space */}
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <AIChatPanel />
      </div>
    </div>
  );
};

export default AskAIPage;
